/**
 * Highlights the search term in the given text.
 * 
 * @param {string} text - The text in which to highlight the search term.
 * @param {string} searchTerm - The term to highlight in the text.
 * 
 * @return {string} - The text with the search term highlighted.
 */
export const highlightSearchTerm = ( text, searchTerm ) => {
	if ( ! text || ! searchTerm ) return text;

	// Function to remove diacritics from a string
	const removeDiacritics = (str) => str.normalize('NFD').replace(/\p{Diacritic}/gu, '');

	// Normalize the search term
	const normalizedSearchTerm = removeDiacritics( searchTerm );

	// Split the text into words and spaces
	const words = text.split(" ");

	// Loop over each segment, normalize, compare, and highlight if matched
	const highlightedText = words.map( ( segment ) => {
		const normalizedSegment = removeDiacritics( segment );

		if ( normalizedSegment.includes( normalizedSearchTerm ) ) {

			if ( normalizedSegment === segment ) {
				// No diacritics,replace the search term in the segment with highlighted version.	
				const regex = new RegExp( searchTerm, 'gi' );
				return segment.replace( regex, ( match ) => `<span style="background:yellow">${match}</span>` );
			}

			const firstLetterOfSearchTerm = normalizedSearchTerm.charAt(0);
			const LastLetteOfSearchTerm = normalizedSearchTerm.charAt(normalizedSearchTerm.length - 1);

			// find the index of the first letter of the search term in the segment
			const indexOfFirstLetter = segment.indexOf( firstLetterOfSearchTerm );
			// find the index of the last letter of the search term in the segment, but it should be after the first letter by the length of the search term
			const indexOfLastLetter = segment.indexOf( LastLetteOfSearchTerm, indexOfFirstLetter + normalizedSearchTerm.length - 1 );
				
			return segment.slice( 0, indexOfFirstLetter ) + `<span style="background:yellow">` + segment.slice( indexOfFirstLetter, indexOfLastLetter + 1 ) + `</span>` + segment.slice( indexOfLastLetter + 1 );

		}
		return segment;
	} ).join( ' ' );

	return highlightedText;
};
